import React, { Component } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { getNbrCotisants } from "../../../../actions/thunks/statistics";
import { connect } from "react-redux";
import { S3_GEOJSON_FOLDER_URL } from "Config";

class BelgiumCityMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      period: props.eventStatsFilter.year,
    };

  }

  geoJsonCache = null;
  geoJsonPromise = null;

  componentDidMount() {
    this.map = L.map("map").setView([50.5, 4.5], 7);

    if (this.geoJsonCache) {
      this.addGeoLayer(this.geoJsonCache);
      return;
    }

    if (!this.geoJsonPromise) {
      this.geoJsonPromise = fetch(
        `${S3_GEOJSON_FOLDER_URL}/billing/geojson/belgium.geojson`
      ).then(res => res.json());
    }

    this.geoJsonPromise.then(data => {
      this.geoJsonCache = data;
      this.addGeoLayer(data);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if cityPercentageData has changed
    if (this.props.cityPercentageData !== prevProps.cityPercentageData && this.map || this.props.firstVariant !== prevProps.firstVariant || this.props.secondVariant !== prevProps.secondVariant || this.props.thirdVariant !== prevProps.thirdVariant) {
      // Clear existing layers
      this.map.eachLayer((layer) => {
        if (layer instanceof L.GeoJSON) {
          this.map.removeLayer(layer);
        }
      });

      // Re-add the GeoJSON layer with updated data
      if (this.geoJsonCache) {
        this.addGeoLayer(this.geoJsonCache);
      }
    }
  }

  componentWillUnmount() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  addGeoLayer = (geoData) => {
    L.geoJSON(geoData, {
      style: (feature) =>
        this.getCityStyle(feature, this.props.cityPercentageData),
      onEachFeature: (feature, layer) =>
        this.addCityTooltip(feature, layer, this.props.cityPercentageData),
    }).addTo(this.map);
  };


  // Define the city style based on the percentage data
  getCityStyle = (feature, cityPercentageData) => {
    const cityName = feature.properties.name; // Adjust based on your GeoJSON properties

    const nbrInscription = cityPercentageData && cityPercentageData[cityName] ? cityPercentageData[cityName][0] : 0;

    return {
      color: "#757575", // Black border color
      weight: 0.8, // Adjust border thickness
      opacity: 1, // Full opacity for border
      fillColor: this.getColorBasedOnPercentage(nbrInscription), // Fill color based on percentage
      fillOpacity: 1, // Transparency for the fill
    };
  };

  // Set color based on the percentage value
  getColorBasedOnPercentage = (percentage) => {
    const { firstVariant, secondVariant, thirdVariant } = this.props;
    return percentage > firstVariant
      ? "#2d74d0"
      : percentage > secondVariant
        ? "#4582e4"
        : percentage > thirdVariant
          ? "#88b0ed"
          : "#dddddd";
  };

  // Add tooltips to show percentage
  addCityTooltip = (feature, layer, cityPercentageData) => {
    const cityName = feature.properties.name; // Adjust based on your GeoJSON properties
    const nbrInscription = cityPercentageData && cityPercentageData[cityName] ? cityPercentageData[cityName][0] : 0;
    const ca = cityPercentageData && cityPercentageData[cityName] ? `${cityPercentageData[cityName][1] / 100} €` : '0 €';
    layer.bindTooltip(`${cityName}: ${nbrInscription}, ${ca}`);
  };

  // componentWillUnmount() {
  //   // Clean up the map instance
  //   if (this.map) {
  //     this.map.remove();
  //   }
  // }

  render() {
    return <div id="map" style={{ width: "100%", height: "300px", zIndex: 1 }} />;
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
  getNbrCotisants,
};

export default connect(mapStateToProps, mapDispatchToProps)(BelgiumCityMap);;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/BelgiumMap.js